import { setRangeMax } from './helpers';

export const setMaxLandArea = setRangeMax('site');
